import React from "react";
import * as Icon from "react-feather";
import { all_routes } from "../../Router/all_routes";

const routes = all_routes;

export const SidebarData = [
  {
    label: "Main",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Dashboard",
        link: routes?.dashboard,
        icon: <Icon.Grid />,
        submenu: false,
        showSubRoute: false,
      },
    ],
  },
  {
    label: "Sales",
    submenuOpen: true,
    submenuHdr: "Sales",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Sales",
        link: routes?.sales,
        icon: <Icon.ShoppingCart />,
        showSubRoute: false,
        submenu: false,
        permission: ['sale_invoice_create', 'sale_invoice_update', 'sale_invoice_delete', 'sale_invoice_read'] // Add permission property
      },
      // {
      //   label: "Invoice Report",
      //   link: routes?.invoiceReport,
      //   icon: <Icon.ShoppingCart />,
      //   showSubRoute: false,
      //   submenu: false,
      //   permission: "sale_invoice_read", // Add permission property
      // },
    ],
  },
  {
    label: "Delivery Management",
    submenuOpen: true,
    submenuHdr: "Delivery Management",
    submenu: false,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Delivery",
        link: routes?.deliveries,
        icon: <Icon.ShoppingCart />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_deliveries", // Add permission property
      },
    ],
  },
  {
    label: "Purchases",
    submenuOpen: true,
    submenuHdr: "Purchases",
    showSubRoute: false,
    submenuItems: [
      {
        label: "Purchases",
        link: routes?.purchases,
        icon: <Icon.ShoppingBag />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_purchases", // Add permission property
      },
    ],
  },
  {
    label: "Stock Management",
    submenuOpen: true,
    submenuHdr: "Stock",
    submenu: true,
    showSubRoute: false,
    submenuItems: [
      {
        label: "Manage Stock",
        link: routes.manageStock,
        icon: <Icon.Package />,
        showSubRoute: false,
        submenu: false,
        // permission: "manage_stock", // Add permission property
      },
      // {
      //   label: "Stock Transfer",
      //   link: routes.stockTransfers,
      //   icon: <Icon.Truck />,
      //   showSubRoute: false,
      //   submenu: false,
      //   // permission: "view_stock_transfers", // Add permission property
      // },
    ],
  },
  {
    label: "Inventory",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: "Products",
        link: routes?.products,
        icon: <Icon.Box />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_products", // Add permission property
      },
      {
        label: "Category",
        link: routes?.categories,
        icon: <Icon.Codepen />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_categories", // Add permission property
      },
      {
        label: "Brands",
        link: routes?.brands,
        icon: <Icon.Tag />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_brands", // Add permission property
      },
      {
        label: "Bay",
        link: routes?.bays,
        icon: <Icon.Database />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_bays", // Add permission property
      },
      // {
      //   label: "Size",
      //   link: routes?.sizes,
      //   icon: <Icon.Speaker />,
      //   showSubRoute: false,
      //   submenu: false,
      //   // permission: "view_sizes", // Add permission property
      // },
      {
        label: "Section",
        link: routes?.sections,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_sections", // Add permission property
      },
      {
        label: "Payment Head",
        link: routes?.paymentHeads,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_payment_heads", // Add permission property
      },
      {
        label: "Service Type",
        link: routes?.serviceTypes,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_service_types", // Add permission property
      },
      {
        label: "Delivery Type",
        link: routes?.deliveryTypes,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_delivery_types", // Add permission property
      },
      {
        label: "Delivery Time Slot",
        link: routes?.deliveryTimeSlots,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_delivery_time_slots", // Add permission property
      },
      {
        label: "State",
        link: routes?.states,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_states", // Add permission property
      },
      {
        label: "City",
        link: routes?.cities,
        icon: <Icon.Layers />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_cities", // Add permission property
      },
    ],
  },
  {
    label: "People",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "People",
    submenuItems: [
      {
        label: "Customers",
        link: routes?.customers,
        icon: <Icon.User />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_sale_persons", // Add permission property
      },
      {
        label: "Sale Persons",
        link: routes?.salePersons,
        icon: <Icon.User />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_sale_persons", // Add permission property
      },
      {
        label: "Suppliers",
        link: routes?.suppliers,
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_suppliers", // Add permission property
      },
      {
        label: "Branch/Stores",
        link: routes?.stores,
        icon: <Icon.Home />,
        showSubRoute: false,
        submenu: false,
        // permission: "view_stores", // Add permission property
      },
    ],
  },
  {
    label: "User Management",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "User Management",
    submenuItems: [
      {
        label: "Users",
        link: routes?.users,
        icon: <Icon.Users />,
        showSubRoute: false,
        // permission: "view_users", // Add permission property
      },
      // {
      //   label: "Roles",
      //   link: routes?.roles,
      //   icon: <Icon.UserCheck />,
      //   showSubRoute: false,
      //   // permission: "view_users", // Add permission property
      // },
    ],
  },
];
